//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const ListService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unittype/list/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    deleteUnitType: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unittype/list/delete", { id }, successCallback, failureCallback);
    },
    getAllUnitTypes: (successCallback, failureCallback) => {
        ApiService.post("/web/admin/unittype/list/getallunittypes", { }, successCallback, failureCallback);
    }
};

export default ListService;
